import { defiItemFields } from '@/pages/defi-exposure/models/defi-fields'
export default {
  getShowCreateEditModal: state => state.showCreateEditModal ?? false,
  getModalAction: state => state.modalAction ?? 'create',
  getCreateEditModalData: state =>
    state.createEditModalData ?? defiItemFields(),

}
